import { render, staticRenderFns } from "./r-discovery-dialog.vue?vue&type=template&id=9f027b4c&scoped=true"
import script from "./r-discovery-dialog.vue?vue&type=script&lang=js"
export * from "./r-discovery-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-discovery-dialog.vue?vue&type=style&index=0&id=9f027b4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f027b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f027b4c')) {
      api.createRecord('9f027b4c', component.options)
    } else {
      api.reload('9f027b4c', component.options)
    }
    module.hot.accept("./r-discovery-dialog.vue?vue&type=template&id=9f027b4c&scoped=true", function () {
      api.rerender('9f027b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/discovery/r-discovery-dialog.vue"
export default component.exports